import { Styles, generateClasses } from 'netline-ui';

export const mobileLanguageSelectorClasses = generateClasses('MobileLanguageSelector', ['content'] as const);

const styles: Styles = ({ theme: { spacing } }) => ({
  [`.${mobileLanguageSelectorClasses.content}`]: {
    margin: spacing(2, 2),
  },
});

export default styles;
